import React from "react";
import { useNavigate } from "react-router-dom";

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-default-99">
      <div className="text-center">
        <p className="text-6xl font-bold text-border-gray mb-4">404</p>
        <p className="text-gray-500 mb-6">Page not found</p>
        <button
          onClick={() => navigate("/")}
          className="text-sm text-link-blue underline"
        >
          Go to overview
        </button>
      </div>
    </div>
  );
};
